import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { logoutFunction } from "shared/api/authApi";
import { CenteredBryxLoader } from "shared/components/global/Loaders/BryxLoader";
import { logger } from "shared/utils/logger";

/**
 * @public
 */
export const Route = createFileRoute("/logout")({
    component: () => {
        const auth = useAuth();

        useEffect(() => {
            if (auth.isLoading || !!window.interop) return;
            async function logoutWrapper() {
                if (auth.isAuthenticated) await logoutFunction(auth);
                window.location.href = "/login";
            }

            logoutWrapper().catch(logger.error);
        }, [auth.isLoading]);

        return <CenteredBryxLoader />;
    },
});
